import React from 'react';
import { FaEnvelope, FaMapMarkerAlt, FaPhone, FaUser, FaComment } from 'react-icons/fa';
import HeadingWithWatermark from '../component/HeadingWithWatermark';
import Navbar from '../component/Navbar';
import Footer from '../component/Footer';

// Theme colors
const primaryBlue = 'rgb(43, 147, 208)';
const yellowAccent = '#fbbf24';

const ContactPage = () => {
  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here
    alert('Form submitted (demo)');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100">
   <Navbar/>

      {/* Main Content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
                 <HeadingWithWatermark
          title="Contact Us"
          watermarkText="WASME"
          color="#1b73a7"
          align="center"
          
        />
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            We'd love to hear from you. Send us a message and we'll respond as soon as possible.
          </p>
        </div>

        {/* Two-column layout */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-16">
          {/* Left Column: Contact Info & Image */}
          <div className="space-y-6">
            {/* Contact Info Cards */}
            <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
              <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
                <span className="w-1 h-6 rounded-full mr-3" style={{ backgroundColor: primaryBlue }}></span>
                Get in Touch
              </h2>
              
              {/* Email */}
              <div className="flex items-start space-x-4 mb-6">
                <div className="p-3 rounded-lg" style={{ backgroundColor: primaryBlue + '10' }}>
                  <FaEnvelope className="text-xl" style={{ color: primaryBlue }} />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900 mb-1">Email</h3>
                  <p className="text-gray-600">wasme@wasmeinfo.org</p>
                  <p className="text-gray-600">info@wasmeinfo.org</p>
                </div>
              </div>

              {/* Office */}
              <div className="flex items-start space-x-4 mb-6">
                <div className="p-3 rounded-lg" style={{ backgroundColor: primaryBlue + '10' }}>
                  <FaMapMarkerAlt className="text-xl" style={{ color: primaryBlue }} />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900 mb-1">Visit WASME</h3>
                  <p className="text-gray-600">Wasme House, Plot No.4, Film City</p>
                  <p className="text-gray-600">Noida Sector 16A, U.P., India</p>
                </div>
              </div>

              {/* Phone */}
              <div className="flex items-start space-x-4">
                <div className="p-3 rounded-lg" style={{ backgroundColor: primaryBlue + '10' }}>
                  <FaPhone className="text-xl" style={{ color: primaryBlue }} />
                </div>
                <div>
                  <h3 className="font-medium text-gray-900 mb-1">Phone</h3>
                  <p className="text-gray-600">+91-9560-685-555</p>
                  <p className="text-gray-600">+91-120-4216-283</p>
                </div>
              </div>
            </div>

            {/* Office Image - fixed representation */}
            <div className="relative rounded-2xl overflow-hidden shadow-xl h-64">
              <img
                src="/img/wasme_office2.jpeg" // Replace with actual image path
                alt="WASME Office"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent flex items-end">
                <div className="p-6 text-white">
                  <h3 className="text-xl font-semibold">WASME Headquarters</h3>
                  <p className="text-sm opacity-90">Noida, India</p>
                </div>
              </div>
            </div>
          </div>

          {/* Right Column: Contact Form */}
          <div className="bg-white rounded-2xl shadow-lg p-8 border border-gray-100">
            <h2 className="text-2xl font-semibold text-gray-800 mb-6 flex items-center">
              <span className="w-1 h-6 rounded-full mr-3" style={{ backgroundColor: yellowAccent }}></span>
              Send a Message
            </h2>
            <form onSubmit={handleSubmit} className="space-y-5">
              {/* Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Name</label>
                <div className="relative">
                  <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Your full name"
                    className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[rgb(43,147,208)] focus:border-transparent"
                    required
                  />
                </div>
              </div>

              {/* Email */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <div className="relative">
                  <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="email"
                    placeholder="you@example.com"
                    className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[rgb(43,147,208)] focus:border-transparent"
                    required
                  />
                </div>
              </div>

              {/* Phone Number */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                <div className="relative">
                  <FaPhone className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="tel"
                    placeholder="+91 98765 43210"
                    className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[rgb(43,147,208)] focus:border-transparent"
                  />
                </div>
              </div>

              {/* Purpose (dropdown) */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Purpose</label>
                <select
                  className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[rgb(43,147,208)] focus:border-transparent"
                  required
                >
                  <option value="">Select a purpose</option>
                  <option value="general">General Inquiry</option>
                  <option value="scheme">Scheme Information</option>
                  <option value="partnership">Partnership</option>
                  <option value="event">Event/Conference</option>
                  <option value="other">Other</option>
                </select>
              </div>

              {/* Message */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <div className="relative">
                  <FaComment className="absolute left-3 top-3 text-gray-400" />
                  <textarea
                    rows="4"
                    placeholder="Your message..."
                    className="w-full pl-10 pr-4 py-3 rounded-lg border border-gray-300 focus:outline-none focus:ring-2 focus:ring-[rgb(43,147,208)] focus:border-transparent"
                    required
                  ></textarea>
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full py-3 rounded-lg text-white font-medium hover:opacity-90 transition-opacity shadow-md"
                style={{ backgroundColor: primaryBlue }}
              >
                Submit
              </button>
            </form>
          </div>
        </div>

        {/* Google Map Banner */}
        <div className="rounded-2xl overflow-hidden shadow-xl border border-gray-200">
          <iframe
            title="WASME Office Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3502.361847264109!2d77.3123!3d28.6139!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjjCsDM2JzUwLjAiTiA3N8KwMTgnNDQuMCJF!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin"
            width="100%"
            height="350"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            className="w-full"
          ></iframe>
        </div>
      </main>

    <Footer/>
    </div>
  );
};

export default ContactPage;